import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import initialState from "../../../reducers/communications/initialState";
import {DefaultBtn} from "Ncontracts.Common.UI";
import {TOGGLE_REPLACE_RECIPIENTS_WARNING} from "../../../actions/communications/newCommunicationAction";

class NewCommunicationSelectedRecipients extends Component {

    static propTypes = {
        selectedContacts: PropTypes.array,
        showWarning: PropTypes.func
    };

    static defaultProps = {
        ...initialState
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {selectedContacts} = this.props;

        const addRecipientsButton = <DefaultBtn className="btn--default"
                                                onClick={() => this.props.showWarning()}>Add Recipients</DefaultBtn>;

        const recipientCards = selectedContacts != null && selectedContacts.length > 0
            ? <>
                <div className="recipient-list">
                    <div className="recipient-selection-list">
                        <div className="list-header columns is-mobile">
                            <div className="name-header column">
                                <span className="column-header">
                                    Name
                                </span>
                            </div>
                            <div className="location-header column">
                                <span className="column-header">
                                    Location
                                </span>
                            </div>
                            <div className="type-header column">
                                <span className="column-header">
                                    Type
                                </span>
                            </div>
                            <div className="organization-header column">
                                <span className="column-header">
                                    Organization
                                </span>
                            </div>
                        </div>
                        <div className="list-body">
                            {selectedContacts.map(r => (
                                <div className="list-row columns is-mobile" key={r.id}>
                                    <div className="name-cell column">{r.displayName}</div>
                                    <div className="location-cell column">{r.location}</div>
                                    <div className="type-cell column">{r.type}</div>
                                    <div className="organization-cell column">{r.organization}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </>
            : <div>No recipients selected</div>;

        return (
            <div className="selected-recipients-container">
                <div className="recipient-list-container">
                    <div className="recipient-list-header">
                        <div className="page-title is-pulled-left">Recipient List</div>
                        <div className="recipient-list-btn-add-recipients is-pulled-right">
                            {addRecipientsButton}
                        </div>
                    </div>
                    <div className="recipient-list-content">
                        {recipientCards}
                    </div>
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    selectedContacts: state.newCommunication.selectedRecipients,
});

const mapDispatchToProps = dispatch => ({
    showWarning: () => dispatch({type: TOGGLE_REPLACE_RECIPIENTS_WARNING})
});

export default connect(mapStateToProps, mapDispatchToProps)(NewCommunicationSelectedRecipients);
